<template>
  <div>
    <v-card elevation="2" tile>
      <v-layout
        wrap
        justify-start
        :style="
          $route.path != '/admin'
            ? ' background-color: #766BC0 '
            : ' background-color: #FFFFFF '
        "
      >
        <v-flex
          xs12
          py-2
          :style="$route.path == '/admin' ? ' color: black ' : ' color: white '"
        >
          <v-layout wrap justify-space-around hidden-md-and-down>
            <v-flex
              xs12
              align-self-center
              lg3
              class="text-left pl-2 nsbold"
              style="font-size: 18px; font-weight: 500"
            >
              <router-link
                to="/"
                style="text-decoration: none !important"
                :style="
                  $route.path == '/admin' ? ' color: black ' : ' color: white '
                "
              >
                School & Bus Management System
              </router-link>
            </v-flex>
            <v-flex xs12 lg7 px-4 text-center>
              <v-layout wrap justify-center>
                <v-flex xs12 align-self-center>
                  <v-btn
                    :style="
                      $route.name == item.name
                        ? 'border-bottom:2px solid white;padding-bottom:6px'
                        : ''
                    "
                    v-for="(item, i) in card"
                    :key="i"
                    class="btn nsbold"
                    @click="$router.push({ path: item.route })"
                    text
                    tile
                  >
                    <span
                      :style="
                        $route.path !== '/admin' ? 'color:white' : 'color:black'
                      "
                    >
                      {{ item.name }}
                    </span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 lg2 px-4 text-right>
              <v-menu offset-y left>
                <template v-slot:activator="{ attrs, on }">
                  <v-layout wrap justify-center v-bind="attrs" v-on="on">
                    <v-flex xs12 text-center align-self-center>
                      <v-icon
                        size="25"
                        title="Account"
                        :style="
                          $route.path !== '/admin'
                            ? 'color:white'
                            : 'color:black'
                        "
                      >
                        mdi-account
                      </v-icon>
                    </v-flex>
                    <v-flex
                      class="hidden-xs-only"
                      xs12
                      text-center
                      align-self-center
                      style="line-height: 0.5"
                      pt-1
                    >
                      <span
                        class="bold"
                        :style="
                          $route.path !== '/admin'
                            ? 'color:white'
                            : 'color:black'
                        "
                      >
                        Admin
                      </span>
                    </v-flex>
                  </v-layout>
                </template>
                <v-card tile flat :elevation="0" max-width="200px">
                  <v-layout wrap justify-center py-4>
                    <v-flex pt-4 xs12 text-center>
                      <span
                        style="font-size: 16px; color: #000000"
                        class="nsbold"
                      >
                        Welcome
                      </span>
                    </v-flex>
                    <v-flex pt-2 xs12 text-center>
                      <v-icon color="#CCB4B4" size="30">
                        mdi-account-circle-outline
                      </v-icon>
                    </v-flex>
                    <v-flex xs12 text-center>
                      <span
                        style="font-size: 13px; color: #1e1b1b"
                        class="nsbold"
                      >
                        <span> {{ appUser.name }} </span>
                      </span>
                    </v-flex>
                    <v-flex xs12 pa-4>
                      <v-btn
                        small
                        block
                        dark
                        dense
                        color="#766BC0"
                        @click="appLogout"
                      >
                        log out
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 px-4>
                      <v-btn
                        small
                        block
                        dark
                        dense
                        color="#766BC0"
                        @click="changePassdialogue = true"
                      >
                        Change Password
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-menu>
            </v-flex>
          </v-layout>
          <!----------------------xs header----------------------->
          <v-layout wrap justify-space-between class="hidden-lg-and-up">
            <v-flex xs1 sm1 md1 align-self-center>
              <v-app-bar-nav-icon
                :color="$route.path != '/admin' ? '#ffffff' : '#766BC0'"
                @click="nav = true"
              ></v-app-bar-nav-icon>
              <v-navigation-drawer
                height="450px"
                absolute
                temporary
                v-model="nav"
              >
                <v-layout class="menufont1" wrap justify-center pa-3>
                  <v-flex xs12 align-self-center>
                    <v-list dense nav>
                      <v-list-item
                        v-for="item in items"
                        :key="item.title"
                        link
                        :to="item.route"
                      >
                        <v-list-item-icon>
                          <v-img :src="item.src" contain width="25px"></v-img>
                        </v-list-item-icon>

                        <v-list-item-content v-if="!item.subMenu">
                          <v-list-item-title>{{
                            item.title
                          }}</v-list-item-title>
                        </v-list-item-content>

                        <!-- <v-list-item-content v-if="item.subMenu"> -->
                        <v-list-group
                          :value="false"
                          v-if="item.subMenu"
                          style="margin-left: -7px !important"
                        >
                          <template v-slot:activator>
                            <v-list-item-content>
                              <v-list-item-title>
                                {{ item.title }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </template>

                          <v-list-item
                            v-for="(sub, s) in item.subMenu"
                            :key="s"
                            link
                            dense
                            :to="sub.route"
                          >
                            <!-- <v-list-item-icon>
                              <v-img
                                :src="sub.src"
                                contain
                                width="25px"
                              ></v-img>
                            </v-list-item-icon> -->
                            <v-list-item-title>
                              {{ sub.title }}
                            </v-list-item-title>
                          </v-list-item>
                        </v-list-group>
                        <!-- </v-list-item-content> -->
                      </v-list-item>
                    </v-list>
                  </v-flex>
                </v-layout>
              </v-navigation-drawer>
            </v-flex>
            <v-flex
              xs6
              sm9
              md9
              align-self-center
              class="text-left pl-2 pt-1 nsbold"
              style="font-size: 18px; font-weight: 500"
              >School Demo
            </v-flex>
            <v-flex xs3 sm2 md2 px-4 align-self-center text-right>
              <!-- <v-btn class="nsbold" text @click="appLogout()">
                <span> LOGOUT </span>
              </v-btn> -->
              <v-menu offset-y left>
                <template v-slot:activator="{ attrs, on }">
                  <v-layout wrap justify-center v-bind="attrs" v-on="on">
                    <v-flex xs12 text-center align-self-center>
                      <v-icon
                        size="25"
                        title="Account"
                        :style="
                          $route.path !== '/admin'
                            ? 'color:white'
                            : 'color:black'
                        "
                      >
                        mdi-account
                      </v-icon>
                    </v-flex>
                    <v-flex
                      class="hidden-xs-only"
                      xs12
                      text-center
                      align-self-center
                      style="line-height: 0.5"
                      pt-1
                    >
                      <span
                        class="bold"
                        :style="
                          $route.path !== '/admin'
                            ? 'color:white'
                            : 'color:black'
                        "
                      >
                        Admin
                      </span>
                    </v-flex>
                  </v-layout>
                </template>
                <v-card tile flat :elevation="0" max-width="200px">
                  <v-layout wrap justify-center py-4>
                    <v-flex pt-4 xs12 text-center>
                      <span
                        style="font-size: 16px; color: #000000"
                        class="nsbold"
                      >
                        Welcome
                      </span>
                    </v-flex>
                    <v-flex pt-2 xs12 text-center>
                      <v-icon color="#CCB4B4" size="30">
                        mdi-account-circle-outline
                      </v-icon>
                    </v-flex>
                    <v-flex xs12 text-center>
                      <span
                        style="font-size: 13px; color: #1e1b1b"
                        class="nsbold"
                      >
                        <span> {{ appUser.name }} </span>
                      </span>
                    </v-flex>
                    <v-flex xs12 pa-4>
                      <v-btn
                        small
                        block
                        dark
                        dense
                        color="#766BC0"
                        @click="appLogout"
                      >
                        log out
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 px-4>
                      <v-btn
                        small
                        block
                        dark
                        dense
                        color="#766BC0"
                        @click="changePassdialogue = true"
                      >
                        Change Password
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-menu>
            </v-flex>
          </v-layout>
          <!------------------------------------------------------>
          <!-- </v-toolbar> -->
          <!-- </v-app-bar> -->
        </v-flex>
        <!------------------------------banner---------------------------->
        <v-layout
          v-if="$route.path != '/' && $route.path == '/admin'"
          wrap
          class="pa-6 bg"
          style="font-family: 'Nunito Sans', sans-serif"
        >
          <v-flex xs12>
            <v-layout wrap>
              <v-flex xs7 pl-3 full-width white--text>
                <p style="font-size: 25px; font-weight: 800" class="my-0">
                  Admin Dashboard
                </p>
                <!-- <p style="font-size: 18px; font-weight: 400">
                  Chavara Public School
                </p> -->
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout wrap justify-center>
              <v-flex
                xs6
                md2
                sm2
                lg2
                align-self-center
                v-for="card in card2"
                :key="card.name"
                pa-1
                pl-3
                pl-xl-0
                class="text-left"
                style="font-family: 'Nunito Sans', sans-serif"
              >
                <v-layout justify-center wrap>
                  <v-flex align-self-center px-xl-12 py-xl-4>
                    <v-card
                      :to="card.route"
                      elevation="2"
                      color="white"
                      hover
                      :ripple="false"
                      max-height="150"
                      :max-width="
                        $vuetify.breakpoint.name == 'xl' ? '100%' : '152'
                      "
                    >
                      <v-card-text
                        style="overflow-y: auto; height: 180px; width: 170px"
                      >
                        <v-img
                          width="40px"
                          :src="getImageURL(card.src)"
                        ></v-img>
                        <v-layout wrap>
                          <v-flex xs12 pt-2>
                            <span class="title1 nsbold">{{
                              card.name.slice(0, 50)
                            }}</span>
                          </v-flex>
                        </v-layout>
                        <v-layout wrap>
                          <v-flex xs12 pt-5 class="text-wrap">
                            <span class="text1 text-wrap">{{ card.role }}</span>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!---------------------------------------------------------->
      </v-layout>
    </v-card>
    <v-dialog width="400px" v-model="changePassdialogue">
      <v-card width="400px">
        <v-toolbar dark color="#766BC0" dense flat class="body-2">
          <v-toolbar-title>Change Password </v-toolbar-title>
        </v-toolbar>

        <v-layout wrap v-if="currentPHN">
          <v-flex xs12 px-4 py-2>
            <v-text-field
              v-model="currentPHN"
              outlined
              dense
              label="Phone"
              disabled
            ></v-text-field>
          </v-flex>
          <v-flex xs12 px-4 pb-2>
            <v-text-field
              v-model="oldpass"
              outlined
              @change="checkPass()"
              dense
              label="Enter current password"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 px-4 pb-2>
            <v-text-field
              :disabled="res == false ? true : false"
              v-model="newpass"
              outlined
              dense
              label="Enter new password"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-card-actions class="pt-3">
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            text
            class="body-2 font-weight-bold"
            @click="changePassdialogue = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="body-2 font-weight-bold"
            outlined
            @click="changePass()"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      :timeout="1000"
      :value="true"
      centered
      color="red"
      v-model="snackbar"
    >
      <span style="font-size: 20px"> {{ msg }}</span>
    </v-snackbar>
  </div>
</template>
<script>
import store from "./../store";
import axios from "axios";
export default {
  data() {
    return {
      user: {},
      nav: false,
      //password items
      oldpass: null,
      newpass: null,
      snackbar: false,
      msg: null,
      res: false,
      changePassdialogue: false,
      //
      //navbar
      items: [
        {
          title: "School Bus",
          src: require("../assets/images/clsndtchr.png"),
          // route: "/SchoolBus",
          subMenu: [
            {
              title: "Home",
              src: require("../assets/images/dash.png"),
              route: "/SchoolBus",
            },
            {
              title: "Places",
              src: require("../assets/images/place.png"),
              route: "/AddPlaces",
            },
            {
              title: "Section",
              src: require("../assets/images/section.png"),
              route: "/AddSection",
            },
            {
              title: "Route",
              src: require("../assets/images/route.png"),
              route: "/AddRoute",
            },
            {
              title: "School Bus",
              src: require("../assets/images/Bus.png"),
              route: "/AddBus",
            },
            {
              title: "Trip",
              src: require("../assets/images/trip.png"),
              route: "/SetTrip",
            },
            {
              title: "Trip Log",
              src: require("../assets/images/trip.png"),
              route: "/TripLog",
            },

            {
              title: "Map Students",
              src: require("../assets/images/trip.png"),
              route: "/MapStudentTrip",
            },
            
        {
          title: "Notifications",
          src: require("../assets/images/trip.png"),
          route: "/SendNotification",
        },
        {
          title: "Tracking",
          src: require("../assets/images/trip.png"),
          route: "/Tracking",
        },
        {
          title: "Leaves",
          src: require("../assets/images/trip.png"),
          route: "/LeaveList",
        },
          ],
        },
        {
          title: "Students",
          src: require("../assets/images/analytic.png"),
          route: "/student",
        },
        {
          title: "Staffs",
          src: require("../assets/images/analytic.png"),
          route: "/student",
        },
        {
          title: "Noticeboard",
          src: require("../assets/images/student.png"),
          route: "/student",
        },
        {
          title: "Topper Video",
          src: require("../assets/images/staff.png"),
          route: "/student",
        },
        {
          title: "Profile",
          src: require("../assets/images/noticeboard.png"),
          route: "/student",
        },
      ],
      //header
      card: [
        {
          src: "clsndtchr.png",
          name: "School Bus",
          route: "/SchoolBus",
        },
        {
          src: "analytic.png",
          name: "Students",
          role: "Add clothes for washing",
          route: "/student",
        },

        {
          src: "student.png",
          name: "Admins",
          role: "Add admins",
          route: "/addAdmin",
        },
        {
          src: "staff.png",
          name: "Add Hostel/School",
          role: "Add Hostel",
          route: "/addHostel",
        },
        {
          src: "noticeboard.png",
          name: "Add Feedback",
          role: "Add Student Feedback",
          route: "/feedback",
        },
        {
          src: "analytic.png",
          name: "Feedback Report",
          role: "Report",
          route: "/feedbackReport",
        },
        // {
        //   src: "noticeboard.png",
        //   name: "Profile",
        //   role: "Washing status",
        //   route: "/student",
        // },
      ],
      //banner
      card2: [
        {
          src: "analytic.png",
          name: "Laundry",
          role: "Laundry Report",
          route: { name: "adLaundryHistory" },
        },
        {
          src: "student.png",
          name: "Student",
          role: "View/Add Student Profile",
          route: { name: "student" },
        },
        {
          src: "staff.png",
          name: "Admins",
          role: "Manage Admins",
          route: { name: "student" },
        },
        {
          src: "noticeboard.png",
          name: "Assets",
          role: "Bills, Report",
          route: { name: "adminAsset" },
        },
        {
          src: "clsndtchr.png",
          name: "Hostel",
          role: "Outpass,Visitor, Attendance,Reports",
          route: { name: "adminHostel" },
        },
        {
          src: "subjectlogo.svg",
          name: "Food",
          role: "Suppliers, Purchase, Bills",
          route: { name: "adminFood" },
        },
        // {
        //   src: "exmlogo.svg",
        //   name: "Exam",
        //   role: "Add / View",
        //   flex: 3,
        //   route: { name: "student" },
        // },
      ],
    };
  },
  computed: {
    appLogin() {
      return store.state.userData;
    },
    appUser() {
      return store.state.userData;
    },
    currentPHN() {
      return store.state.userData.phone;
    },
    curRole() {
      return store.state.userData.role;
    },
  },
  methods: {
    getImageURL(src) {
      let images = require.context("../assets/images/");
      return images("./" + src);
    },
    checkPass() {
      axios({
        method: "post",
        url: "/check/oldpassword",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          phone: this.currentPHN,
          oldpassword: this.oldpass,
        },
      })
        .then((response) => {
          // this.changePassdialogue = false;
          // this.appLoading = false;
          if (response.data.status == true) {
            this.res = response.data.status;
            console.log(this.res);
            //  this.snackbar = true;
            // this.msg = response.data.msg;
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }

          // this.msg = response.data.msg;

          // this.snackbar = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    changePass() {
      this.appLoading = true;
      axios({
        method: "post",
        url: "/change/password",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          phone: this.currentPHN,
          newPassword: this.newpass,
        },
      })
        .then((response) => {
          this.changePassdialogue = false;
          this.appLoading = false;
          if (response.data.status == true) {
            this.res = response.data.data;
            (this.oldpass = null),
              (this.newpass = null),
              (this.snackbar = true);
            this.msg = response.data.msg;
            setTimeout(() => this.appLogout(), 2000);
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }

          // this.msg = response.data.msg;

          // this.snackbar = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    appLogout() {
      axios({
        method: "post",
        url: "/admin/logout",
        headers: {
          token: localStorage.getItem("token"),
        },
      }).then((response) => {
        localStorage.removeItem("token");
        if (response.data.status) {
          store.state.userType = null;
          store.state.isLoggedIn = false;
          store.state.userData = {};
          store.state.initial = "";
          localStorage.removeItem("userType");
          localStorage.removeItem("token");
          this.$router.push("/");
        }
      });
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@200;400;600;700;800&display=swap");
.bgblue {
  background-color: #766bc0 !important;
}
.bggrey {
  background-color: #312e2e !important;
}
.bg {
  background: url("../assets/images/Asset2.png") 0% 0% no-repeat padding-box;
  opacity: 1;
}
.btn {
  text-transform: unset !important;
}

a {
  color: black;
  text-decoration: none;
}

.router-link-exact-active a {
  color: black;
}
.changee {
  font-size: 30px !important;
}
</style>
